module.exports = __webpack_public_path__ + "static/media/introThird.4e0deba1.png";